export function getModalPortalOwnerId(
  trigger: HTMLElement | null | undefined,
): string | undefined {
  if (!trigger) {
    return undefined;
  }
  const dialog = trigger.closest<HTMLElement>('[role="dialog"]');
  return dialog?.id || undefined;
}
